import React from 'react';
import ChangePasswordModal from './changePasswordModal';
import './changePassword.css';

const ChangePassword = ({ translate, oldPassword, newPassword, newPasswordConfirmation, passwordUpdateStatus,
                          handleChange, toggleVisible, checkCapsLock, isCapslock, submitForm, errors }) => {

  const status = passwordUpdateStatus === 'ok';

  if (status) { window.$('#change-password-modal').modal('hide') }
  return (
    <div className="reset-password reset-password--item">
      {!status && <ChangePasswordModal
        translate={translate}
        oldPassword={oldPassword}
        newPassword={newPassword}
        handleChange={handleChange}
        newPasswordConfirmation={newPasswordConfirmation}
        toggleVisible={toggleVisible}
        checkCapsLock={checkCapsLock}
        isCapslock={isCapslock}
        submitForm={submitForm}
        passwordUpdateStatus={passwordUpdateStatus}
        errors={errors}
      />}
      <button
        data-toggle="modal"
        data-target="#change-password-modal"
        className="btn btn-success btn-sm reset-password--button">
        <i
          className={`fa ${status ? 'fa-check' : 'fa-lock'}`}
        />
        <span>
          {translate(`session.password_reset.${ !status ? 'change' : 'changed'}`)}
        </span>
      </button>
    </div>
  )
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/main/settings/changePassword.js